<script setup lang="ts">
// import type { TagFragment } from '#graphql-operations'

const { tag, reset = false } = defineProps<{
  tag: any
  reset?: boolean
}>()
</script>

<template>
  <AppLink
    v-if="tag?.Tag"
    :to="reset ? $route.path : `${$route.path}?tag=${tag.Tag?.replace(' ', '+')}`"
    class="blog-tag"
    :class="{
      'blog-tag--current': tag?.Tag === $route.query?.tag || (reset && !$route.query?.tag && tag?.Tag !== $route.query?.tag),
    }"
  >
    <span>{{ tag.Tag }}</span>
  </AppLink>
</template>

<style>
@import url("~layers/components/Blog/Tag.css");
</style>
